import { zergApi } from "@/service/zerg";

class SettingBonusService {

    async createOrUpdate(params) {
        try {
            const data = await zergApi.post('setting/payroll/bonus/create-or-update-bonus', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    
    async listBonus(params) {
        try {
            const data = await zergApi.post('setting/payroll/bonus/list-bonus', params);
            return data;
        } catch (error) {
            throw error;
        }
    }


}

export default new SettingBonusService();